<template>
  <table
    :class="[
      'table',
      'b-skeleton-table',
      {
        [`b-skeleton-table-${variant}`]: variant
      }
    ]"
  >
    <thead v-if="!hideHeader">
      <tr>
        <th
          v-for="c in columns"
          :key="c"
        >
          <BSkeleton
            :animation="animation"
            :class="{ [`b-skeleton-${variant}`]: variant }"
          />
        </th>
      </tr>
    </thead>

    <tbody>
      <tr
        v-for="r in rows"
        :key="r"
      >
        <td
          v-for="c in columns"
          :key="c"
        >
          <BSkeleton
            width="75%"
            :animation="animation"
            :class="{ [`b-skeleton-${variant}`]: variant }"
          />
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import BSkeleton from './BSkeleton.vue'

export default {
  name: 'BSkeletonTable',
  components: {
    BSkeleton
  },
  props: {
    variant: {
      type: String
    },
    animation: {
      type: String
    },
    columns: {
      type: Number,
      default: 5
    },
    rows: {
      type: Number,
      default: 3
    },
    hideHeader: Boolean
  }
}
</script>

<style lang="scss" scoped>
@import "~@ui/styles/src/scss/utils/lib";

.b-skeleton-table {
  th {
    border-bottom-width: 1px;
  }

  &.b-skeleton-table-dark {
    border-color: $grey-30;
    border-style: solid;
    border-width: 1px;

    td, th {
      border-color: $grey-30;
    }
  }
}
</style>
